import { Redirect, Route, Switch } from 'react-router-dom';
import { PATHS } from 'services/router';
import { PolicyItem } from 'views/PolicyV2/PolicyItem';
import { PolicyList } from 'views/PolicyV2/PolicyList';

function PoliciesRoute() {
	return (
		<Switch>
			<Route path={PATHS.POLICY_LIST} component={PolicyList} exact />
			<Route path={PATHS.POLICY_ITEM} component={PolicyItem} />

			<Redirect to={PATHS.POLICY_LIST} />
		</Switch>
	);
}

export default PoliciesRoute;
